var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"ods-header",style:({ height: _vm.height }),attrs:{"data-name":"OdsHeader"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }